

























import { Component, Vue } from 'vue-property-decorator';
import { SERVICES, SERVICES_LOGO } from '@/data/services';
import AuthModule from '@/store/AuthModule';

@Component({})
export default class ServicesSelector extends Vue {
    services() {
        return Object.fromEntries(
            Object.entries(SERVICES).filter(([key]) => !(key === 'lead' && AuthModule.isRestricted))
        );
    }

    getLogo(key: string): string {
        return SERVICES_LOGO[key] || 'GridIcon';
    }

    setStateService(service: string) {
        if (service == "academy") {
            return window.open(`https://academie.plugimmo.pro/login?email=${AuthModule.email}`, '_blank');
        }
        localStorage.setItem('service', service);
        return location.reload();
    }

    actualService() {
        return localStorage.getItem('service');
    }
}
